export default __webpack_public_path__ + "static/media/signUp.a7040c41.jpeg";